import { ButtonGroup, Col, Input, Label } from "reactstrap";
import { Btn } from "../../../../AbstractElements";
import { OptionOne, OptionTwo } from "../../../../Constant";
import { CHECKBOX_BUTTON_LIST } from "../../../../Data/Buttons/ButtonGroup";
import { ButtonGroupProp } from "../../../../Type/Buttons";

export const DynamicCheckBoxButtonGroup = () => {
  return (
    <>
      {CHECKBOX_BUTTON_LIST.map(({ idOne, color, idTwo }: ButtonGroupProp, index) => (
        <Col xl="4" md="6" sm="12" key={index}>
            <ButtonGroup className="btn-option">
              <Btn color={color}>
                <div className={`checkbox checkbox-${color}`}>
                  <Input id={`checkbox${idOne}`} type="checkbox" />
                  <Label htmlFor={`checkbox${idOne}`}>{OptionOne}</Label>
                </div>
              </Btn>
              <Btn color={color}>
                <div className={`checkbox checkbox-${color}`}>
                  <Input id={`checkbox${idTwo}`} type="checkbox" />
                  <Label htmlFor={`checkbox${idTwo}`}>{OptionTwo}</Label>
                </div>
              </Btn>
            </ButtonGroup>
        </Col>
      ))}
    </>
  );
};
